export default __webpack_public_path__ + "static/icon_ichi_xichi-a48eab9a589c011b18637afc0d7b89e3.svg";